export const Services = [
  {
    s_no: "01",
    s_name: "Web design",
    s_desc: "Web development is the process of building, programming, and maintaining websites."
  },
  {
    s_no: "02",
    s_name: "Graphics design",
    s_desc: "Creating visually appealing designs for branding, marketing, and digital presence."
  },
  {
    s_no: "03",
    s_name: "Social media",
    s_desc: "Managing and optimizing social media platforms to increase engagement and reach."
  },
  {
    s_no: "04",
    s_name: "App design",
    s_desc: "Designing intuitive and user-friendly mobile and web applications."
  },
  {
    s_no: "05",
    s_name: "SEO Optimization",
    s_desc: "Improving website rankings on search engines for better visibility and traffic."
  },
  {
    s_no: "06",
    s_name: "Content Writing",
    s_desc: "Creating engaging and SEO-friendly content for websites, blogs, and businesses."
  },
  {
    s_no: "07",
    s_name: "E-commerce Solutions",
    s_desc: "Building and optimizing e-commerce websites for seamless online shopping experiences."
  },
  {
    s_no: "08",
    s_name: "UI/UX Design",
    s_desc: "Crafting aesthetically pleasing and highly functional user interfaces and experiences."
  },
  {
    s_no: "09",
    s_name: "Digital Marketing",
    s_desc: "Strategizing and executing digital marketing campaigns for business growth."
  }
];

export const Pricing = [
  {
      id: 1,
      title: "Static Website",
      price: "KES 50,000",
      tag: "Basic",
      features: [
          "Free Domain Name",
          "Website Security",
          "Free Lifetime Hosting",
          "1-5 Pages",
          "3 Professional Emails",
          "Fast Loading Speed",
          "Unique Designs",
          "SEO Optimization",
          "Google Business Setup",
          "24/7 Support"
      ]
  },
  {
      id: 2,
      title: "E-commerce",
      price: "From KES 100,000",
      tag: "Popular",
      features: [
          "Free Domain Name",
          "Enhanced Security",
          "5 Professional Emails",
          "Custom Store Design",
          "SEO Optimization",
          "Google Business Setup",
          "M-Pesa Integration",
          "Card Payments",
          "Admin Dashboard",
          "Sales Analytics",
          "24/7 Support"
      ]
  },
  {
      id: 3,
      title: "Mobile App",
      price: "From KES 200,000",
      tag: "Premium",
      features: [
          "Native iOS & Android",
          "5 Professional Emails",
          "Fast Performance",
          "Store Publishing",
          "User Authentication",
          "Push Notifications",
          "Analytics Integration",
          "Real-time Sync",
          "API Integration",
          "24/7 Support"
      ]
  },
  {
      id: 4,
      title: "Dynamic Website",
      price: "From KES 100,000",
      features: [
          "CMS Integration",
          "Database Management",
          "Free Domain",
          "Content Updates",
          "User Management",
          "Advanced Search",
          "Custom Design",
          "Fast Performance",
          "Auto Backups",
          "24/7 Support"
      ],
      idealFor: ["News", "Education", "Forums", "Directories"]
  }
];
